module.exports = __webpack_public_path__ + "static/media/php.43a44928.png";